import { render, staticRenderFns } from "./LaborUsage.vue?vue&type=template&id=95eb2af0&"
import script from "./LaborUsage.vue?vue&type=script&lang=js&"
export * from "./LaborUsage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports